import { createStore, derive } from 'store-utils';
import { createConnectivityBannerInfo } from '../actions/connectivity-actions';
import { NoConnectivityBannerInfo } from '../connector-connectivity-types';
import { Connector, ConnectorsByFamilyObject } from '../connectors-types';
import { findConnectivityIssues } from '../utils/connectors-utils';

const baseStore = createStore<ConnectorsStoreState>(
  {
    connectors: [],
    connectorsByFamily: [],
    loadingConnectors: true,
    filteredConnectorsByFamily: [],
    credentialsValidationInProgress: false,
    showValidationMsg: false,
    validationMsgObj: undefined,
    validationError: false,
    singleConnectorValidationInProgress: false,
    showSingleValidationMsg: false,
    singleConnectorIsValid: undefined,
    singleConnectorIsEmptyOfRepos: undefined,
    connectorsDiscoveredNumber: 0,
    searchValue: '',
    scanType: undefined,
    connectivityBannerDismissed: false,
    isDemoEnabled: false,
  },
  'Connector Store',
);

const ConnectorsStore = derive(
  {
    connectorsIssues: get => {
      const { connectorsByFamily } = get(baseStore);
      return findConnectivityIssues(connectorsByFamily);
    },
    noConnectionBanner: (get): NoConnectivityBannerInfo | undefined => {
      const { scanType, connectorsByFamily } = get(baseStore);

      // waiting for 'dashboardInfo' to load
      if (!scanType) {
        return;
      }
      const info = createConnectivityBannerInfo(connectorsByFamily);
      return info;
    },
  },
  {
    proxy: baseStore,
  },
);

interface ConnectorsStoreState {
  connectors: Connector[];
  connectorsByFamily: ConnectorsByFamilyObject[];
  loadingConnectors: boolean;
  filteredConnectorsByFamily: ConnectorsByFamilyObject[];
  credentialsValidationInProgress: boolean;
  showValidationMsg: boolean;
  validationMsgObj?: {
    msg: string;
    color: string;
  };
  validationError: boolean;
  singleConnectorValidationInProgress: boolean;
  showSingleValidationMsg: boolean;
  singleConnectorIsValid?: boolean;
  singleConnectorIsEmptyOfRepos?: boolean;
  connectorsDiscoveredNumber: number;
  searchValue: string;
  scanType?: string;
  connectivityBannerDismissed: boolean;
  isDemoEnabled: boolean;
}

export default ConnectorsStore;
